import React from 'react';
import PropTypes from 'prop-types';
import { StyledWrap, WrapperAvatar, StyleIcon, StyledAvatar } from './style';
import { AvatarComment } from '../../../../assets/images/index';
import { AVATAR_MEDIUM } from '../../../utils/crops';

const AvatarComments = ({
  className,
  pathImage,
  name,
  lastname,
  userId,
  avatarPhoto
}) => (
  <StyledWrap className={className}>
    <StyleIcon size="xl" svg={AvatarComment} />
    <WrapperAvatar>
      <StyledAvatar
        pathImage={pathImage}
        name={name}
        lastname={lastname}
        userId={userId}
        crop={AVATAR_MEDIUM}
        avatarPhoto={avatarPhoto}
        linkProfile
      />
    </WrapperAvatar>
  </StyledWrap>
);

AvatarComments.propTypes = {
  pathImage: PropTypes.string,
  name: PropTypes.string,
  lastname: PropTypes.string,
  userId: PropTypes.string,
  avatarPhoto: PropTypes.bool
};

export default AvatarComments;
